import DecorHero from './DecorHero.component';

export default DecorHero;